import { BiInfoCircle } from "react-icons/bi";

const InfoText = ({ tooltip, link, className = "" }) => {
  const handleClick = e => {
    e.stopPropagation();

    if (link) {
      window.open(link, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <span className={`info-text ${className}`}>
      <BiInfoCircle onClick={handleClick} className="info-icon" />

      {tooltip && <span className="info-tooltip">{tooltip}</span>}
    </span>
  );
};

export default InfoText;
